"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateCachingReport = exports.CacheEntryListener = exports.CacheListener = void 0;
const cache = __importStar(require("@actions/cache"));
class CacheListener {
    constructor() {
        this.cacheEntries = [];
        this.cacheReadOnly = false;
        this.cacheWriteOnly = false;
        this.cacheDisabled = false;
        this.cacheDisabledReason = 'disabled';
    }
    get fullyRestored() {
        return this.cacheEntries.every(x => !x.wasRequestedButNotRestored());
    }
    get cacheStatus() {
        if (!cache.isFeatureAvailable())
            return 'not available';
        if (this.cacheDisabled)
            return this.cacheDisabledReason;
        if (this.cacheWriteOnly)
            return 'write-only';
        if (this.cacheReadOnly)
            return 'read-only';
        return 'enabled';
    }
    entry(name) {
        for (const entry of this.cacheEntries) {
            if (entry.entryName === name) {
                return entry;
            }
        }
        const newEntry = new CacheEntryListener(name);
        this.cacheEntries.push(newEntry);
        return newEntry;
    }
    stringify() {
        return JSON.stringify(this);
    }
    static rehydrate(stringRep) {
        if (stringRep === '') {
            return new CacheListener();
        }
        const rehydrated = Object.assign(new CacheListener(), JSON.parse(stringRep));
        const entries = rehydrated.cacheEntries;
        for (let index = 0; index < entries.length; index++) {
            const rawEntry = entries[index];
            entries[index] = Object.assign(new CacheEntryListener(rawEntry.entryName), rawEntry);
        }
        return rehydrated;
    }
}
exports.CacheListener = CacheListener;
class CacheEntryListener {
    constructor(entryName) {
        this.entryName = entryName;
    }
    wasRequestedButNotRestored() {
        return this.requestedKey !== undefined && this.restoredKey === undefined;
    }
    markRequested(key, restoreKeys = []) {
        this.requestedKey = key;
        this.requestedRestoreKeys = restoreKeys;
        return this;
    }
    markRestored(key, size) {
        this.restoredKey = key;
        this.restoredSize = size;
        return this;
    }
    markNotRestored(message) {
        this.notRestored = message;
        return this;
    }
    markSaved(key, size) {
        this.savedKey = key;
        this.savedSize = size;
        return this;
    }
    markAlreadyExists(key) {
        this.savedKey = key;
        this.savedSize = 0;
        return this;
    }
    markNotSaved(message) {
        this.notSaved = message;
        return this;
    }
}
exports.CacheEntryListener = CacheEntryListener;
function generateCachingReport(listener) {
    const entries = listener.cacheEntries;
    return `
<details>
<summary><h4>Caching for gradle-build-action was ${listener.cacheStatus} - expand for details</h4></summary>
${renderEntryTable(entries)}

<h5>Cache Entry Details</h5>
<pre>
    ${renderEntryDetails(listener)}
</pre>
</details>
    `;
}
exports.generateCachingReport = generateCachingReport;
function renderEntryTable(entries) {
    return `
<table>
    <tr><td></td><th>Count</th><th>Total Size (Mb)</th></tr>
    <tr><td>Entries Restored</td>
        <td>${getCount(entries, e => e.restoredSize)}</td>
        <td>${getSize(entries, e => e.restoredSize)}</td>
    </tr>
    <tr><td>Entries Saved</td>
        <td>${getCount(entries, e => e.savedSize)}</td>
        <td>${getSize(entries, e => e.savedSize)}</td>
    </tr>
</table>
    `;
}
function renderEntryDetails(listener) {
    return listener.cacheEntries
        .map(entry => {
        var _a, _b, _c;
        return `Entry: ${entry.entryName}
    Requested Key : ${(_a = entry.requestedKey) !== null && _a !== void 0 ? _a : ''}
    Restored  Key : ${(_b = entry.restoredKey) !== null && _b !== void 0 ? _b : ''}
              Size: ${formatSize(entry.restoredSize)}
              ${getRestoredMessage(entry, listener.cacheWriteOnly)}
    Saved     Key : ${(_c = entry.savedKey) !== null && _c !== void 0 ? _c : ''}
              Size: ${formatSize(entry.savedSize)}
              ${getSavedMessage(entry, listener.cacheReadOnly)}
`;
    })
        .join('---\n');
}
function getRestoredMessage(entry, cacheWriteOnly) {
    if (entry.notRestored) {
        return `(Entry not restored: ${entry.notRestored})`;
    }
    if (cacheWriteOnly) {
        return '(Entry not restored: cache is write-only)';
    }
    if (entry.requestedKey === undefined) {
        return '(Entry not restored: not requested)';
    }
    if (entry.restoredKey === undefined) {
        return '(Entry not restored: no match found)';
    }
    if (entry.restoredKey === entry.requestedKey) {
        return '(Entry restored: exact match found)';
    }
    return '(Entry restored: partial match found)';
}
function getSavedMessage(entry, cacheReadOnly) {
    if (entry.notSaved) {
        return `(Entry not saved: ${entry.notSaved})`;
    }
    if (entry.savedKey === undefined) {
        if (cacheReadOnly) {
            return '(Entry not saved: cache is read-only)';
        }
        if (entry.notRestored) {
            return '(Entry not saved: not restored)';
        }
        return '(Entry not saved: reason unknown)';
    }
    if (entry.savedSize === 0) {
        return '(Entry not saved: entry with key already exists)';
    }
    return '(Entry saved)';
}
function getCount(cacheEntries, predicate) {
    return cacheEntries.filter(e => predicate(e)).length;
}
function getSize(cacheEntries, predicate) {
    const bytes = cacheEntries.map(e => { var _a; return (_a = predicate(e)) !== null && _a !== void 0 ? _a : 0; }).reduce((p, v) => p + v, 0);
    return Math.round(bytes / (1024 * 1024));
}
function formatSize(bytes) {
    if (bytes === undefined || bytes === 0) {
        return '';
    }
    return `${Math.round(bytes / (1024 * 1024))} MB (${bytes} B)`;
}
